exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.big.el-select[data-v-38936654] {\n  width: 450px;\n}\n.biggest.el-textarea[data-v-38936654], .biggest.el-input[data-v-38936654] {\n  max-width: 700px;\n  width: 100%;\n}\n.el-checkbox__label[data-v-38936654] {\n  background-color: transparent;\n}\n.el-form-item__content[data-v-38936654] {\n  line-height: 20px;\n}\n.el-form-item__label[data-v-38936654] {\n  text-align: right;\n  float: left;\n  font-size: 14px;\n  color: #606266;\n  line-height: 20px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.el-form-item[data-v-38936654] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n  padding-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38936654","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/roleSpecific/PrintDecisionJudgment.vue
// module id = iemV
// module chunks = 1